import { computed, toValue } from 'vue'
import type { UseSearchConfig } from '@onxmaps/search-web-vue'
import {
  searchMode,
  getStatesFilter,
  getIsoStateNames,
} from '@/services/search-service'
import { SearchMode } from '@/services/search-service/constants'

/**
 * Augments a base search config with mode-appropriate filters.
 * In Landowner mode, applies private scope and state entitlement restrictions
 * to both the search filter and autocomplete config.
 */
export const useSearchPrivateLandFilter = (
  baseConfig: UseSearchConfig
): UseSearchConfig => {
  const isLandownerMode = () => searchMode() === SearchMode.Landowner

  const landownerStates = computed(() => {
    return getStatesFilter()
  })

  const filter = computed(() => {
    if (!isLandownerMode()) {
      return toValue(baseConfig.filter) ?? {}
    }

    return {
      ...toValue(baseConfig.filter),
      searchScopeFilter: { slug: { eq: 'private' } },
      ...(landownerStates.value.length && {
        withinStates: getIsoStateNames(landownerStates.value),
      }),
    }
  })

  const autocompleteConfig = computed(() => {
    if (!isLandownerMode()) {
      return toValue(baseConfig.autocompleteConfig) ?? {}
    }

    return {
      ...toValue(baseConfig.autocompleteConfig),
      withinScopes: 'private',
      ...(landownerStates.value.length && {
        withinStates: getIsoStateNames(landownerStates.value, false).join(','),
      }),
    }
  })

  return {
    ...baseConfig,
    filter,
    autocompleteConfig,
  }
}
